export default [
  { to: "/servers", name: "server_predef" },
  { to: "/contacts", name: "contacts" },
  { to: "/about", name: "about" },
];
